import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Lock, Mail } from "lucide-react";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin/dashboard", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin/dashboard", { replace: true });
    } catch (err) {
      setError(apiError(err, "Correo o contraseña incorrectos"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-scope flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <h1 className="font-serif text-4xl text-white">Yocaira Abreu</h1>
          <p className="overline-label mt-1">Panel administrativo</p>
        </div>
        <form data-testid="admin-login-form" onSubmit={submit} className="bg-[#18181B] border border-[#27272A] rounded-lg p-8">
          <div className="space-y-5">
            <div className="relative">
              <Mail size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#C5A059]" />
              <input
                data-testid="admin-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Correo electrónico"
                className="w-full bg-[#0F0F10] border border-[#27272A] rounded-md pl-10 pr-4 py-3 text-white outline-none focus:border-[#C5A059] transition-colors"
              />
            </div>
            <div className="relative">
              <Lock size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#C5A059]" />
              <input
                data-testid="admin-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Contraseña"
                className="w-full bg-[#0F0F10] border border-[#27272A] rounded-md pl-10 pr-4 py-3 text-white outline-none focus:border-[#C5A059] transition-colors"
              />
            </div>
            {error && <p data-testid="admin-login-error" className="text-red-400 text-sm">{error}</p>}
            <button
              data-testid="admin-login-submit"
              disabled={loading}
              className="w-full py-3 rounded-md bg-[#C5A059] text-[#0A0A0A] font-semibold hover:bg-[#E5C887] transition-colors disabled:opacity-60"
            >
              {loading ? "Ingresando…" : "Iniciar sesión"}
            </button>
          </div>
        </form>
        <button onClick={() => navigate("/")} className="mt-6 w-full text-center text-sm text-[#8C8375] hover:text-[#C5A059] transition-colors">
          ← Volver al sitio
        </button>
      </div>
    </div>
  );
}
